import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type IFlameSignalData } from '../services/getFlameSignaGraphDataServiceNew'

export interface IFlameSignalDataState {
  isLoading: boolean
  error: string | null
  signalData: any | null
  httpStatus: number | undefined
}

const initialState: IFlameSignalDataState = {
  isLoading: false,
  error: null,
  signalData: null,
  httpStatus: 0
}

const flowSignalParamDataSlice = createSlice({
  name: 'flameSignalParamData',
  initialState,
  reducers: {
    flowSignalParamDataLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        signalData: null,
        httpStatus: 0
      }
    },
    flowSignalParamDataUpdateAction: (state, action: PayloadAction<{ data: IFlameSignalData, httpStatus: number }>) => {
      console.log(action, 'datadatasa')
      return {
        isLoading: false,
        error: null,
        signalData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    flowSignalParamDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        signalData: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  flowSignalParamDataLoadingAction,
  flowSignalParamDataUpdateAction,
  flowSignalParamDataErrorAction
} = flowSignalParamDataSlice.actions

export default flowSignalParamDataSlice.reducer
